import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,App } from 'ionic-angular';
import {UpdateinfoloadingsrPage} from '../updateinfoloadingsr/updateinfoloadingsr'
import { DocumentstatementPage } from '../documentstatement/documentstatement';
import {PartpaymentPage} from '../partpayment/partpayment'

import {EmiempirelatedPage} from '../emiempirelated/emiempirelated'
import { OdpaymentPage } from '../odpayment/odpayment';
import {CancelMandatePage} from '../cancel-mandate/cancel-mandate';

@IonicPage()
@Component({
  selector: 'page-newservicerequest',
  templateUrl: 'newservicerequest.html',
})
export class NewservicerequestPage {
  loanstatus:boolean=true;
  paymentMode:boolean = true;
  totalAmount:any=0
  constructor(public navCtrl: NavController, public navParams: NavParams,private app:App) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad NewservicerequestPage',this.navParams);
    if(this.navParams.data.loanParameterDetail.responseParameters[0].loanstatus=='Active'){
      this.loanstatus=false
    }

     // this.odpaymentArr = this.navParams.data.paymentMode;
       
      this.navParams.data.paymentMode.forEach((res:any)=>{
        this.totalAmount=parseInt(this.totalAmount)+parseInt(res.chargeamt)
      })
      if(this.navParams.data.paymentMode.length>0 && this.totalAmount>200){
        this.paymentMode=false
      }else{
        this.paymentMode=true
      }
    
     
    
  }
goToPageName(pageName){
  let nav = this.app.getRootNav();
  if(pageName=='updateinfolandingsr'){
    // //console.log(UpdateinfoloadingsrPage)
    nav.push(UpdateinfoloadingsrPage,this.navParams)
  }else if(pageName=='documentstatement'){
    // //console.log(pageName)
    nav.push(DocumentstatementPage,this.navParams)
  }else if(pageName=='partpayment'){
    //console.log(pageName)
    nav.push(PartpaymentPage,this.navParams)
  }else if(pageName=='odpayment'){
    //console.log(pageName)
    nav.push(OdpaymentPage,this.navParams)
  }else if(pageName=='cancelmandate'){
    //console.log(pageName)
    nav.push(CancelMandatePage,this.navParams)
  }

  else{
     
    nav.push(EmiempirelatedPage,this.navParams)
  }
  
}
}



// WEBPACK FOOTER //
// ./src/pages/newservicerequest/newservicerequest.ts